import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import InsertDriveFileRounded from "@material-ui/icons/InsertDriveFileOutlined";
import { Box } from "@material-ui/core";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Doughnut } from 'react-chartjs-2';

import DashboardCard from "../../../../components/DashboardCard/index";

function PerformanceAutomation(props) {
	const { t } = useTranslation();

    const indicators = useSelector(
        ({ requests }) =>
            requests.queries.FETCH_COUNT_INVOICE_INDICATOR &&
            requests.queries.FETCH_COUNT_INVOICE_INDICATOR.data
    );

    const chartData = {
        labels: [t("complete"), t("partial")],
        datasets: [
            {
                data: [indicators?.totalAutomaticInvoices || 0, indicators?.totalManualInvoices || 0],
                backgroundColor: ['#4caf50', '#e0e0e0'], 
                borderWidth: 0,
                hoverBackgroundColor: ['#4caf50', '#e0e0e0']
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        rotation: 1 * Math.PI,      
        circumference: 1 * Math.PI, 
        cutoutPercentage: 80,       
        legend: { display: false },
        tooltips: { enabled: true },
    };

	return (
        <DashboardCard
            title={t("performance_automation")}
            icon={InsertDriveFileRounded}
            {...props} 
        >
            <Grid container spacing={2} justify="center">
                <Grid item xs={12}>
                    <Box style={{ width: '100%', padding: '0 16px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                        <div style={{ position: 'relative', height: '120px', width: '100%', marginBottom: '10px' }}>
                            <Doughnut data={chartData} options={chartOptions} />
                            
                            <div style={{
                                position: 'absolute',
                                top: '60%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                textAlign: 'center'
                            }}>
                                <Typography variant="h5" style={{ fontWeight: 'bold', color: '#333' }}>
                                    {indicators?.touchlessRate?.toFixed(0) || 0}%
                                </Typography>
                                <Typography variant="caption" color="textSecondary" style={{ display: 'block', lineHeight: 1 }}>
                                    {t("touchless_rate")}
                                </Typography>
                            </div>
                        </div>

                        <Box display="flex" justifyContent="center" mt={-1}>
                            <Box display="flex" alignItems="center" mr={2}>
                                <div style={{ width: 10, height: 10, backgroundColor: '#4caf50', marginRight: 4, borderRadius: 2 }}/>
                                <Typography variant="caption" style={{ fontWeight: 600 }}>
                                    {t("complete")}: {indicators?.totalAutomaticInvoices || 0}
                                </Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <div style={{ width: 10, height: 10, backgroundColor: '#e0e0e0', marginRight: 4, borderRadius: 2 }}/>
                                <Typography variant="caption" style={{ fontWeight: 600 }}>
                                    {t("partial")}: {indicators?.totalManualInvoices || 0}
                                </Typography>
                            </Box>
                        </Box>

                    </Box>
                </Grid>
            </Grid>
        </DashboardCard>
    );
}

export default PerformanceAutomation;
